import { render, staticRenderFns } from "./social.vue?vue&type=template&id=01c9be2f&scoped=true"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"
import style0 from "./social.vue?vue&type=style&index=0&id=01c9be2f&prod&scoped=true&lang=css"
import style1 from "./social.vue?vue&type=style&index=1&id=01c9be2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9be2f",
  null
  
)

export default component.exports